/* eslint-disable prefer-promise-reject-errors */
import * as utils from '@utils/form';
import { IMAGE_SIZE } from '@api/media/constants';

export const EVENT_FEATURE_LINKS_COUNT = 4;

export const FORM_FIELD = {
  EVENT_IMAGE: {
    name: 'image',
    label: 'Panel image:',
    buttonText: 'CHOOSE A NEW LOGO',
    rules: [{ required: true, message: 'A logo is required' }],
    size: IMAGE_SIZE['450x300'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
  },
  EVENT_TITLE: {
    name: 'eventName',
    label: 'Title:',
    placeholder: 'Write a title...',
    rules: [{ required: true, message: 'Title is required' }],
  },
  EVENT_URL: {
    entityName: 'event',
    urlName: 'url',
    placeholder: 'Enter the URL or start typing an event name...',
    rules: [{ required: true, message: 'Url is required' }],
    serialize: utils.entityOrUrlFieldSerialize,
  },
};
export const FORM_FIELDS = Object.values(FORM_FIELD);

export const INITIAL_VALUES = {
  featureLinks: [],
};
